<div class="layers view-menu" [ngClass]="this.menuService.menuOptions['view']? 'active' : ''">
  <div class="layers__container " [ngClass]="this.menuService.menuOptions['view'] ? 'active' : ''">
     <h1>Layers</h1>
      <div class="btn">
        <div class="select_feature" (click)="this.globalSelectionService.setPointerAll()" [ngClass]="this.globalSelectionService.isPointerAll() ? 'active' : ''"></div>
        <div class="polygon_select" (click)="this.globalSelectionService.setBoxAll()" [ngClass]="this.globalSelectionService.isBoxAll() ? 'active' : ''"></div>
        <div class="circle_select" (click)="this.globalSelectionService.setCircleAll()" [ngClass]="this.globalSelectionService.isCircleAll() ? 'active' : ''"></div>
        <div class="clear_select" (click)="this.globalSelectionService.clearAllSelected()" [ngClass]="pointsService.getSelectedFeatures().length>0 ? 'active' : ''"></div>
      </div>
<!-- SELECTION BY FIR -->
      <div class="layers__tab" [ngClass]="this.globalSelectionService.staticLayers.active ? 'active' : ''">
        <div class="title" >
            <p style="width: calc(100% - 70px);">Selection by FIR</p>
            <div title="FIRs Filter" class="filter" style="margin-left: 28px" (click)="this.showSelectionByFir()"></div>
            <!-- If we move the FIR layers to this section, we'll need to enable the titleTrigger again-->
            <!--<span class="titleTrigger"></span>-->
        </div>
      </div>
<!-- END SELECTION BY FIR -->
<!-- AREAS -->
      <div class="layers__tab" [ngClass]="this.globalSelectionService.areasLayers.active ? 'active' : ''">
        <div class="title" >
            <p style="width: calc(100% - 70px);">Areas</p>
            <span class="titleTrigger" (click)="this.globalSelectionService.areasLayers.layersTabTrigger()"></span>
            <div title="Create Area" class="create" (click)="this.addArea()"></div>
            <div title="Delete All Areas" class="deleteAllArea" (click)="this.areaService.deleteAllAreas()" ></div>
        </div>
        <div *ngIf="this.areaService.areas.size > 0">
          <div class="field" *ngFor="let area of this.areaService.areas | keyvalue">
            <div class="layers__tab__sec">
              <div class="options">
                <span (click)="this.areaService.openArea(area.value)" title="Open Area" class="openWindow"></span>
                <span (click)="this.editArea(area.value)" title="Edit Area" class="editWindow"></span>
                <span style="color: red;" (click)="this.areaService.deleteArea(area.value)" class="remove"></span>
                <span [ngStyle]="{'font-weight' : area.value.defaultArea ? 'bold' : ''}" class="text limit-title">{{area.value.name}}</span>
              </div>
            </div>
          </div>
        </div>
      </div>
<!-- END AREAS -->
<!-- ANNOTATIONS -->
    <div class="layers__tab" [ngClass]="this.globalSelectionService.annotationLayers.active ? 'active' : ''">
      <div class="title" (mouseleave)="utilsService.closeHiddenMenu($event)">
        <input type="checkbox" (click)="this.selectLayer('Annotations',this.globalSelectionService.annotationLayers,$event)"
        [checked]="this.globalSelectionService.annotationLayers.allLayersVisible()"/>
        <p style="width: calc(100% - 112px)">Annotations</p>
        <span class="titleTrigger" (click)="this.globalSelectionService.annotationLayers.layersTabTrigger()"></span>
        <div title="Create Annotation" class="create" (mouseover)="utilsService.showHiddenMenu($event)"></div>
        <div class="hiddenMenu down hiddenMenu__mr--48" (mouseleave)="utilsService.closeHiddenMenu($event)">
          <ul>
            <li (click)="this.addAnnotation('LineString')">Add line annotations</li>
            <li (click)="this.addAnnotation('Polygon')">Add polygon annotations</li>
            <li (click)="this.addAnnotation('Circle')">Add circle annotations</li>
            <li (click)="this.addAnnotation('Freehand')">Add freehand annotations</li>
            <li (click)="this.addAnnotation('Text')">Add text annotations</li>
          </ul>
        </div>
        <div title="Delete All Annotations" class="deleteAllArea"(click)="this.annotationService.deleteAllAnnotationsAction()" style="margin-right: 6px;"></div>
        <div class="dots" (mouseover)="utilsService.showHiddenMenu($event)" >...</div>
        <div class="hiddenMenu down hiddenMenu__mr--2" (mouseleave)="utilsService.closeHiddenMenu($event)">
          <ul>
            <li (click)="exportAllAnnotationsToKML(this.globalSelectionService.annotationLayers.childLayers)">Export Data to KML</li>
            <li (click)="exportAllAnnotationsToShapeFile(this.globalSelectionService.annotationLayers.childLayers)">Export Data To ShapeFile</li>
          </ul>
        </div>

      </div>
      <div *ngIf="this.globalSelectionService.annotationLayers.childLayers.length > 0">
        <div class="field" *ngFor="let child of this.globalSelectionService.annotationLayers.childLayers">
          <div class="layers__tab__sec active">
            <div class="options">
              <input style="margin-right: 7px;" type="checkbox" (click)="this.selectLayer('Annotations',child)" [checked]="child.allVisible()" />
              <span (click)="this.moveAnnotation(child)" title="Move Annotation" class="moveWindow"></span>
              <span (click)="this.editAnnotation(child)" title="Edit Annotation" class="editWindow"></span>
              <span style="color: red;" (click)="deleteAnnotationAction(child)" class="remove"></span>
              <div class="dots" (mouseover)="utilsService.showHiddenMenu($event)" >...</div>
              <div class="hiddenMenu" (mouseleave)="utilsService.closeHiddenMenu($event)">
                <ul>
                  <li (click)="mapService.zoomToLayers(child.layers)">Zoom To Layer</li>
                  <li (click)="exportDataService.exportDataToKML(child.layers)">Export Data to KML</li>
                  <li (click)="exportDataService.exportDataToShapeFile(child.layers)">Export Data To ShapeFile</li>
                </ul>
              </div>
              <span class="limit-title">{{child.name}}</span>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- END ANNOTATIONS -->
    <div class="layers__tab" *ngIf="this.globalSelectionService.userLayer.childLayers[0].layers.length > 0"
         [ngClass]="this.globalSelectionService.userLayer.active  ? 'active' : ''">
      <div class="title">
        <input type="checkbox" (click)="selectAll(this.globalSelectionService.userLayer, $event)"
               [checked]="this.globalSelectionService.userLayer.childLayers[0].allVisible()">
        <p>{{this.globalSelectionService.userLayer.name}}</p>
        <span class="titleTrigger" (click)="this.globalSelectionService.userLayer.layersTabTrigger()"></span>
      </div>
      <div>
        <div class="field" *ngFor="let layer of this.globalSelectionService.userLayer.childLayers[0]?.layers; let i=index">
          <input type="checkbox" (click)="this.selectuserLayer(layer)" [checked]="layer.visible">
          <span >{{layer.name}}</span>
          <div class="dots" (mouseover)="utilsService.showHiddenMenu($event)" >...</div>
          <div class="hiddenMenu down mr-0" (mouseleave)="utilsService.closeHiddenMenu($event)">
            <ul>
              <li (click)="showStyleEditor(layer)">Edit Style</li>
              <li (click)="mapService.zoomToLayers([layer])">Zoom To Layer</li>
              <li (click)="mapService.moveLayersToFront([layer])">Move To Front</li>
              <li (click)="mapService.moveLayersToBack([layer])">Move To Back</li>
              <li (click)="exportDataService.exportDataToKML([layer],true)">Export Data to KML</li>
              <li (click)="exportDataService.exportDataToShapeFile([layer])">Export Data To ShapeFile</li>
              <li (click)="deleteUserLayer(i)">Remove Layer</li>
            </ul>
          </div>

        </div>
      </div>
    </div>
    <div class="layers__tab" [ngClass]="this.globalSelectionService.staticLayers.active ? 'active' : ''">
      <div class="title" >
        <input type="checkbox" (click)="this.selectAll(this.globalSelectionService.staticLayers, $event)"
               [checked]="this.configurationService?.currentConfiguration?.allLayersVisible()"/>
        <p>{{this.globalSelectionService.staticLayers.name}}</p>
        <span class="titleTrigger" (click)="this.globalSelectionService.staticLayers.layersTabTrigger()"></span>
      </div>
      <div>
        <div *ngFor="let el of configurationService?.currentConfiguration?.layers;">
          <div [ngClass]="el.enabled? 'field': ''" *ngIf="el.enabled">
            <input *ngIf="el.enabled" type="checkbox" (click)="mapService.activateStaticLayer(el)" [checked]="el.visible"/>
            <span *ngIf="el.enabled">{{el.name}}</span>
            <div *ngIf="el.type == 'GeoJsonLayer' && el.enabled"  class="dots" (mouseover)="utilsService.showHiddenMenu($event)" >...</div>
            <div *ngIf="el.enabled" class="hiddenMenu" (mouseleave)="utilsService.closeHiddenMenu($event)">
              <ul>
                <li (click)="showStyleEditor(el.vectorLayer,true)">Edit Style</li>
                <li (click)="mapService.moveLayersToFront([el.vectorLayer])">Move To Front</li>
                <li (click)="mapService.moveLayersToBack([el.vectorLayer])">Move To Back</li>
                <li (click)="exportDataService.exportDataToKML([el.vectorLayer])">Export Data to KML</li>
                <li (click)="exportDataService.exportDataToShapeFile([el.vectorLayer])">Export Data To ShapeFile</li>
              </ul>
            </div>
          </div>
        </div>
        <div style="padding: 0;" class="field" *ngFor="let child of this.globalSelectionService.staticLayers.childLayers" [ngClass]="child.status ? 'active' : ''">
          <ng-container *ngIf="child.obstacleFileName != null">
            <div>
              <div>
                <div class="layers__tab__sec"  style="padding: 0; margin: 0;width: 99% !important;" [ngClass]="child.status ? 'active' : ''">
                  <div class="title">
                    <input  type="checkbox" (click)="this.obstacleDataService.activateObstacleDataLayer(child)" [checked]="child.allVisible()"/>
                    <span style="width: 227px;" class="trigger" (click)="this.globalSelectionService.staticLayers.clickEvent(child)" title="{{child.obstacleFileName}}">Obstacle Data - {{child.obstacleFileName}}</span>
                    <span (click)="this.deleteStaticObstacleLayer(child)" name="a_delete_icon" class="remove" style="width: 13px;height: 13px;"></span>
                  </div>
                  <div class="layers__tab__third active" >
                    <div>
                      <div class="field" style="padding-left: 20px;">
                          <span>
                            <svg class="test" viewBox="0 0 23.52 21.14"><defs><style>.cls-1,.cls-2{stroke:#000;stroke-miterlimit:10;}</style></defs><g id="Layer_2" data-name="Layer 2"><g id="Layer_1-2" data-name="Layer 1"><rect class="cls-1" x="0.5" y="0.5" width="1.11" height="20.14"/><polygon class="cls-2" [ngStyle]="{ fill : 'blue'}" points="11.81 18.57 1.89 18.57 12.38 0.5 22.64 0.5 11.81 18.57"/></g></g></svg>
                            <span>Human Made</span>
                          </span>
                      </div>
                    </div>
                    <div>
                      <div class="field" style="padding-left: 20px;">
                          <span>
                            <svg class="test" viewBox="0 0 23.52 21.14"><defs><style>.cls-1,.cls-2{stroke:#000;stroke-miterlimit:10;}</style></defs><g id="Layer_2" data-name="Layer 2"><g id="Layer_1-2" data-name="Layer 1"><rect class="cls-1" x="0.5" y="0.5" width="1.11" height="20.14"/><polygon class="cls-2" [ngStyle]="{ fill : 'green'}" points="11.81 18.57 1.89 18.57 12.38 0.5 22.64 0.5 11.81 18.57"/></g></g></svg>
                            <span>Natural</span>
                          </span>
                      </div>
                    </div>
                    <div>
                      <div class="field" style="padding-left: 20px;">
                          <span>
                            <svg class="test" viewBox="0 0 23.52 21.14"><defs><style>.cls-1,.cls-2{stroke:#000;stroke-miterlimit:10;}</style></defs><g id="Layer_2" data-name="Layer 2"><g id="Layer_1-2" data-name="Layer 1"><rect class="cls-1" x="0.5" y="0.5" width="1.11" height="20.14"/><polygon class="cls-2" points="11.81 18.57 1.89 18.57 12.38 0.5 22.64 0.5 11.81 18.57"/></g></g></svg>
                            <span>Unknown</span>
                          </span>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

          </ng-container>
        </div>
      </div>
    </div>


    <!--#region GRIT-->
    <div [ngClass]="this.globalSelectionService.interferenceTestLayer.active ? 'active' : ''" class="layers__tab">
      <div class="title">
        <input (click)="this.selectAll(this.globalSelectionService.interferenceTestLayer, $event)"
               [checked]="this.globalSelectionService.interferenceTestLayer.childLayers[0].allVisible()"
               type="checkbox"/>
        <p>{{ this.globalSelectionService.interferenceTestLayer.name }}</p>
        <div (click)="this.tabsService.openFilterTab(FeatureType.InterferenceTest)" class="filter" title="Interference Test Filter"></div>
        <div (mouseover)="utilsService.showHiddenMenu($event)" class="dots">...</div>
        <div (mouseleave)="utilsService.closeHiddenMenu($event)" class="hiddenMenu hiddenMenu__mr--12">
          <ul>
            <li
              (click)="mapService.moveLayersToFront(this.globalSelectionService.interferenceTestLayer.childLayers[0].layers)">
              Move To Front
            </li>
            <li
              (click)="mapService.moveLayersToBack(this.globalSelectionService.interferenceTestLayer.childLayers[0].layers)">
              Move To Back
            </li>
            <li
              (click)="exportDataService.exportDataToKML(this.globalSelectionService.interferenceTestLayer.childLayers[0].layers)">
              Export Data to KML
            </li>
            <li
              (click)="exportDataService.exportDataToShapeFile(this.globalSelectionService.interferenceTestLayer.childLayers[0].layers)">
              Export Data To ShapeFile
            </li>
          </ul>
        </div>
        <span (click)="this.globalSelectionService.interferenceTestLayer.layersTabTrigger()"
              class="titleTrigger"></span>
      </div>

      <div class="btn">
        <div (click)="this.globalSelectionService.setPointer([this.globalSelectionService.interferenceTestLayer])"
             [ngClass]="this.globalSelectionService.interferenceTestLayer.layersSelector.pointer ? 'active' : ''"
             class="select_feature"></div>
        <!--        <div (click)="this.globalSelectionService.setBoxSelection([this.globalSelectionService.interferenceTestLayer])"-->
        <!--             [ngClass]="this.globalSelectionService.interferenceTestLayer.layersSelector.polygon ? 'active' : ''"-->
        <!--             class="polygon_select"></div>-->
        <!--        <div-->
        <!--          (click)="this.globalSelectionService.setCircleSelection([this.globalSelectionService.interferenceTestLayer])"-->
        <!--          [ngClass]="this.globalSelectionService.interferenceTestLayer.layersSelector.circle ? 'active' : ''"-->
        <!--          class="circle_select"></div>-->
        <div (click)="this.globalSelectionService.clearAllSelected()"
             [ngClass]="pointsService.getSelectedFeaturesOfType(FeatureType.InterferenceTest).length > 0 ? 'active' : ''"
             class="clear_select"></div>
      </div>

      <div>
        <ng-container *ngFor="let layer of this.globalSelectionService.interferenceTestLayer.childLayers[0].layers">
          <ng-container *ngIf="this.projectService.activeProject?.editable || layer.id != 'current'">
            <div class="field">
              <input (click)="selectLayer(FeatureType.InterferenceTest, layer)" [checked]="layer.visible" type="checkbox"/>
              <span> <img alt="" src="{{layer.image}}"/></span>
              <span>{{ layer.name }}</span>
              <div (mouseover)="utilsService.showHiddenMenu($event)" class="dots">...</div>
              <div (mouseleave)="utilsService.closeHiddenMenu($event)" class="hiddenMenu hiddenMenu__mr--2">
                <ul>
                  <li (click)="mapService.moveLayersToFront([layer])">Move To Front</li>
                  <li (click)="mapService.moveLayersToBack([layer])">Move To Back</li>
                  <li (click)="exportDataService.exportDataToKML([layer])">Export Data to KML</li>
                  <li (click)="exportDataService.exportDataToShapeFile([layer])">Export Data To ShapeFile</li>
                </ul>
              </div>
            </div>
          </ng-container>
        </ng-container>
      </div>
    </div>

    <div [ngClass]="this.globalSelectionService.radarLayer.active ? 'active' : ''" class="layers__tab">
      <div class="title">
        <input (click)="this.selectAll(this.globalSelectionService.radarLayer, $event)"
               [checked]="this.globalSelectionService.radarLayer.childLayers[0].allVisible()"
               type="checkbox"/>
        <p>{{ this.globalSelectionService.radarLayer.name }}</p>
        <div (click)="this.tabsService.openFilterTab(FeatureType.Radar)" class="filter" title="Radar Filter"></div>
        <div (mouseover)="utilsService.showHiddenMenu($event)" class="dots">...</div>
        <div (mouseleave)="utilsService.closeHiddenMenu($event)" class="hiddenMenu hiddenMenu__mr--12">
          <ul>
            <li
              (click)="mapService.moveLayersToFront(this.globalSelectionService.radarLayer.childLayers[0].layers)">
              Move To Front
            </li>
            <li
              (click)="mapService.moveLayersToBack(this.globalSelectionService.radarLayer.childLayers[0].layers)">
              Move To Back
            </li>
            <li
              (click)="exportDataService.exportDataToKML(this.globalSelectionService.radarLayer.childLayers[0].layers)">
              Export Data to KML
            </li>
            <li
              (click)="exportDataService.exportDataToShapeFile(this.globalSelectionService.radarLayer.childLayers[0].layers)">
              Export Data To ShapeFile
            </li>
          </ul>
        </div>
        <span (click)="this.globalSelectionService.radarLayer.layersTabTrigger()" class="titleTrigger"></span>
      </div>

      <div class="btn">
        <div (click)="this.globalSelectionService.setPointer([this.globalSelectionService.radarLayer])"
             [ngClass]="this.globalSelectionService.radarLayer.layersSelector.pointer ? 'active' : ''"
             class="select_feature"></div>
        <div (click)="this.globalSelectionService.setBoxSelection([this.globalSelectionService.radarLayer])"
             [ngClass]="this.globalSelectionService.radarLayer.layersSelector.polygon ? 'active' : ''"
             class="polygon_select"></div>
        <div (click)="this.globalSelectionService.setCircleSelection([this.globalSelectionService.radarLayer])"
             [ngClass]="this.globalSelectionService.radarLayer.layersSelector.circle ? 'active' : ''"
             class="circle_select"></div>
        <div (click)="this.globalSelectionService.clearAllSelected()"
             [ngClass]="pointsService.getSelectedFeaturesOfType(FeatureType.Radar).length > 0 ? 'active' : ''"
             class="clear_select"></div>
      </div>

      <div>
        <div *ngFor="let layer of this.globalSelectionService.radarLayer.childLayers[0].layers" class="field">
          <input (click)="selectLayer(FeatureType.Radar, layer)" [checked]="layer.visible" type="checkbox"/>
          <span> <img alt="" src="{{layer.image}}"/></span>
          <span>{{ layer.name }}</span>
          <div (mouseover)="utilsService.showHiddenMenu($event)" class="dots">...</div>
          <div (mouseleave)="utilsService.closeHiddenMenu($event)" class="hiddenMenu hiddenMenu__mr--2">
            <ul>
              <li (click)="mapService.moveLayersToFront([layer])">Move To Front</li>
              <li (click)="mapService.moveLayersToBack([layer])">Move To Back</li>
              <li (click)="exportDataService.exportDataToKML([layer])">Export Data to KML</li>
              <li (click)="exportDataService.exportDataToShapeFile([layer])">Export Data To ShapeFile</li>
            </ul>
          </div>
        </div>
      </div>
    </div>

    <div *editable [ngClass]="this.globalSelectionService.deviceLayer.active ? 'active' : ''" class="layers__tab">
      <div class="title">
        <input (click)="this.selectAll(this.globalSelectionService.deviceLayer, $event)"
               [checked]="this.globalSelectionService.deviceLayer.childLayers[0].allVisible()"
               type="checkbox"/>
        <p>{{ this.globalSelectionService.deviceLayer.name }}</p>
        <div class="filter" style="background: none; border: none; cursor: default "></div>
        <div (mouseover)="utilsService.showHiddenMenu($event)" class="dots">...</div>
        <div (mouseleave)="utilsService.closeHiddenMenu($event)" class="hiddenMenu hiddenMenu__mr--12">
          <ul>
            <li
              (click)="mapService.moveLayersToFront(this.globalSelectionService.deviceLayer.childLayers[0].layers)">
              Move To Front
            </li>
            <li
              (click)="mapService.moveLayersToBack(this.globalSelectionService.deviceLayer.childLayers[0].layers)">
              Move To Back
            </li>
            <li
              (click)="exportDataService.exportDataToKML(this.globalSelectionService.deviceLayer.childLayers[0].layers)">
              Export Data to KML
            </li>
            <li
              (click)="exportDataService.exportDataToShapeFile(this.globalSelectionService.deviceLayer.childLayers[0].layers)">
              Export Data To ShapeFile
            </li>
          </ul>
        </div>
        <span (click)="this.globalSelectionService.deviceLayer.layersTabTrigger()" class="titleTrigger"></span>
      </div>

      <div class="btn">
        <div (click)="this.globalSelectionService.setPointer([this.globalSelectionService.deviceLayer])"
             [ngClass]="this.globalSelectionService.deviceLayer.layersSelector.pointer ? 'active' : ''"
             class="select_feature"></div>
        <div (click)="this.globalSelectionService.setBoxSelection([this.globalSelectionService.deviceLayer])"
             [ngClass]="this.globalSelectionService.deviceLayer.layersSelector.polygon ? 'active' : ''"
             class="polygon_select"></div>
        <div (click)="this.globalSelectionService.setCircleSelection([this.globalSelectionService.deviceLayer])"
             [ngClass]="this.globalSelectionService.deviceLayer.layersSelector.circle ? 'active' : ''"
             class="circle_select"></div>
        <div (click)="this.globalSelectionService.clearAllSelected()"
             [ngClass]="pointsService.getSelectedFeaturesOfType(FeatureType.Device).length > 0 ? 'active' : ''"
             class="clear_select"></div>
      </div>

      <div>
        <div *ngFor="let layer of this.globalSelectionService.deviceLayer.childLayers[0].layers" class="field">
          <input (click)="selectLayer(FeatureType.Device, layer)" [checked]="layer.visible" type="checkbox"/>
          <span> <img alt="" src="{{layer.image}}" style="filter: invert(1);"/></span>
          <span>{{ layer.name }}</span>
          <div (mouseover)="utilsService.showHiddenMenu($event)" class="dots">...</div>
          <div (mouseleave)="utilsService.closeHiddenMenu($event)" class="hiddenMenu hiddenMenu__mr--2">
            <ul>
              <li (click)="mapService.moveLayersToFront([layer])">Move To Front</li>
              <li (click)="mapService.moveLayersToBack([layer])">Move To Back</li>
              <li (click)="exportDataService.exportDataToKML([layer])">Export Data to KML</li>
              <li (click)="exportDataService.exportDataToShapeFile([layer])">Export Data To ShapeFile</li>
            </ul>
          </div>
        </div>
      </div>
    </div>
    <!--endregion-->


    <!--NAVAIDS-->
    <div class="layers__tab" [ngClass]="this.globalSelectionService.navaidsLayers.active ? 'active' : ''" >
      <div class="title" (mouseleave)="utilsService.closeHiddenMenu($event)">
        <input type="checkbox" (click)="this.selectAll(this.globalSelectionService.navaidsLayers, $event)"
               [checked]="this.globalSelectionService.navaidsLayers.childLayers[0].allVisible()"/>

        <!--<input type="checkbox" (click)="this.map.redrawText()" [(ngModel)]="this.pointsService.showNavaidsIdOnMap"/>-->
        <p style="width: calc(100% - 106px);">{{this.globalSelectionService.navaidsLayers.name}}</p>
        <span class="titleTrigger" (click)="this.globalSelectionService.navaidsLayers.layersTabTrigger()"></span>

        <div title="Show and hide navaids ident code" class="text" [ngClass]="this.navaidIdentCodeEnabled? 'active' : ''" (click)="this.redrawText()" name="showNavaidsIdOnMap"></div>

        <div title="Navaids Filter" class="filter" (click)="this.showNavaidFilter()"></div>

        <div class="dots" (mouseover)="utilsService.showHiddenMenu($event)" >...</div>
        <div class="hiddenMenu hiddenMenu__mr--12" (mouseleave)="utilsService.closeHiddenMenu($event)">
          <ul>
            <li (click)="mapService.moveLayersToFront(this.globalSelectionService.navaidsLayers.childLayers[0].layers)">Move To Front</li>
            <li (click)="mapService.moveLayersToBack(this.globalSelectionService.navaidsLayers.childLayers[0].layers)">Move To Back</li>
            <li (click)="exportDataService.exportDataToKML(this.globalSelectionService.navaidsLayers.childLayers[0].layers)">Export Data to KML</li>
            <li (click)="exportDataService.exportDataToShapeFile(this.globalSelectionService.navaidsLayers.childLayers[0].layers)">Export Data To ShapeFile</li>
          </ul>
        </div>

      </div>
      <div class="btn">
        <div class="select_feature" (click)="this.globalSelectionService.setPointer([this.globalSelectionService.navaidsLayers])" [ngClass]="this.globalSelectionService.navaidsLayers.layersSelector.pointer ? 'active' : ''"></div>
        <div class="polygon_select" (click)="this.globalSelectionService.setBoxSelection([this.globalSelectionService.navaidsLayers])" [ngClass]="this.globalSelectionService.navaidsLayers.layersSelector.polygon ? 'active' : ''"></div>
        <div class="circle_select" (click)="this.globalSelectionService.setCircleSelection([this.globalSelectionService.navaidsLayers])" [ngClass]="this.globalSelectionService.navaidsLayers.layersSelector.circle ? 'active' : ''"></div>
        <div class="clear_select" (click)="this.globalSelectionService.clearAllSelected()" [ngClass]="pointsService.getSelectedFeaturesOfType(0).length>0 ? 'active' : ''"></div>
      </div>
      <div>
        <div class="field" *ngFor="let layer of this.globalSelectionService.navaidsLayers.childLayers[0].layers" >
          <input type="checkbox" (click)="selectLayer('Navaids', layer)" [checked]="layer.visible" />
          <span> <img src="/assets/img/{{layer.image}}" alt=""/></span>
          <span>{{layer.name}}</span>
          <div class="dots" (mouseover)="utilsService.showHiddenMenu($event)" >...</div>
          <div class="hiddenMenu hiddenMenu__mr--2" (mouseleave)="utilsService.closeHiddenMenu($event)">
            <ul>
              <li (click)="mapService.moveLayersToFront([layer])">Move To Front</li>
              <li (click)="mapService.moveLayersToBack([layer])">Move To Back</li>
              <li (click)="exportDataService.exportDataToKML([layer])">Export Data to KML</li>
              <li (click)="exportDataService.exportDataToShapeFile([layer])">Export Data To ShapeFile</li>
            </ul>
          </div>
        </div>
      </div>

    </div>
    <div class="layers__tab" [ngClass]="this.globalSelectionService.coordinatePointsLayers.active ? 'active' : ''">
      <div class="title" >
        <input type="checkbox" (click)="this.selectAll(this.globalSelectionService.coordinatePointsLayers, $event)"
               [checked]="this.globalSelectionService.coordinatePointsLayers.childLayers[0].allVisible()"/>
        <p>{{this.globalSelectionService.coordinatePointsLayers.name}}</p>
        <div title="Coordinate Points Filter" class="filter" (click)="this.showCPFilter()"></div>
        <div class="dots" (mouseover)="utilsService.showHiddenMenu($event)">...</div>
        <div class="hiddenMenu hiddenMenu__mr--12" (mouseleave)="utilsService.closeHiddenMenu($event)">
          <ul>
            <li (click)="mapService.moveLayersToFront(this.globalSelectionService.coordinatePointsLayers.childLayers[0].layers)">Move To Front</li>
            <li (click)="mapService.moveLayersToBack(this.globalSelectionService.coordinatePointsLayers.childLayers[0].layers)">Move To Back</li>
            <li (click)="exportDataService.exportDataToKML(this.globalSelectionService.coordinatePointsLayers.childLayers[0].layers)">Export Data to KML</li>
            <li (click)="exportDataService.exportDataToShapeFile(this.globalSelectionService.coordinatePointsLayers.childLayers[0].layers)">Export Data To ShapeFile</li>
          </ul>
        </div>
        <span class="titleTrigger" (click)="this.globalSelectionService.coordinatePointsLayers.layersTabTrigger()"></span>
      </div>
      <div class="btn">
        <div class="select_feature" (click)="this.globalSelectionService.setPointer([this.globalSelectionService.coordinatePointsLayers])" [ngClass]="this.globalSelectionService.coordinatePointsLayers.layersSelector.pointer ? 'active' : ''"></div>
        <div class="polygon_select" (click)="this.globalSelectionService.setBoxSelection([this.globalSelectionService.coordinatePointsLayers])" [ngClass]="this.globalSelectionService.coordinatePointsLayers.layersSelector.polygon ? 'active' : ''"></div>
        <div class="circle_select" (click)="this.globalSelectionService.setCircleSelection([this.globalSelectionService.coordinatePointsLayers])" [ngClass]="this.globalSelectionService.coordinatePointsLayers.layersSelector.circle ? 'active' : ''"></div>
        <div class="clear_select" (click)="this.globalSelectionService.clearAllSelected()" [ngClass]="pointsService.getSelectedFeaturesOfType(1).length>0 ? 'active' : ''"></div>
      </div>
      <div>
        <div class="field" *ngFor="let layer of this.globalSelectionService.coordinatePointsLayers.childLayers[0].layers">
          <input type="checkbox" (click)="selectLayer('Coordinate Points', layer)" [checked]="layer.visible" />
          <span> <img src="/assets/img/{{layer.image}}" alt=""/></span>
          <span>{{layer.name}}</span>
          <div class="dots" (mouseover)="utilsService.showHiddenMenu($event)" >...</div>
          <div class="hiddenMenu hiddenMenu__mr--2" (mouseleave)="utilsService.closeHiddenMenu($event)">
            <ul>
              <li (click)="mapService.moveLayersToFront([layer])">Move To Front</li>
              <li (click)="mapService.moveLayersToBack([layer])">Move To Back</li>
              <li (click)="exportDataService.exportDataToKML([layer])">Export Data to KML</li>
              <li (click)="exportDataService.exportDataToShapeFile([layer])">Export Data To ShapeFile</li>
            </ul>
          </div>
        </div>
      </div>
    </div>

    <!--    <div class="layers__tab" [ngClass]="this.globalSelectionService.proceduresLayers.active ? 'active' : ''">
          <div class="title" >
              <input type="checkbox" (click)="selectAll(this.globalSelectionService.proceduresLayers,$event)"
              [checked]="this.globalSelectionService.proceduresLayers.childLayers[0].allVisible()"/>
              <p>{{this.globalSelectionService.proceduresLayers.name}}</p>
              <div title="Procedures Filter" class="filter" (click)="this.showProcedureFilter()"></div>
              <div class="dots" (mouseover)="utilsService.showHiddenMenu($event)">...</div>
              <div class="hiddenMenu hiddenMenu__mr&#45;&#45;12" (mouseleave)="utilsService.closeHiddenMenu($event)">
                <ul>
                  <li (click)="mapService.moveLayersToFront(this.globalSelectionService.proceduresLayers.childLayers[0].layers)">Move To Front</li>
                  <li (click)="mapService.moveLayersToBack(this.globalSelectionService.proceduresLayers.childLayers[0].layers)">Move To Back</li>
                  <li (click)="exportDataService.exportDataToKML(this.globalSelectionService.proceduresLayers.childLayers[0].layers)">Export Data to KML</li>
                  <li (click)="exportDataService.exportDataToShapeFile(this.globalSelectionService.proceduresLayers.childLayers[0].layers)">Export Data To ShapeFile</li>
                </ul>
              </div>
              <span class="titleTrigger" (click)="this.globalSelectionService.proceduresLayers.layersTabTrigger()"></span>
          </div>
          <div class="btn">
            <div class="select_feature" (click)="this.globalSelectionService.setPointer([this.globalSelectionService.proceduresLayers, this.globalSelectionService.routeSegmentsLayers])" [ngClass]="this.globalSelectionService.proceduresLayers.layersSelector.pointer ? 'active' : ''"></div>
            <div class="polygon_select" (click)="this.globalSelectionService.setBoxSelection([this.globalSelectionService.proceduresLayers, this.globalSelectionService.routeSegmentsLayers])" [ngClass]="this.globalSelectionService.proceduresLayers.layersSelector.polygon  ? 'active' : ''"></div>
            <div class="circle_select" (click)="this.globalSelectionService.setCircleSelection([this.globalSelectionService.proceduresLayers, this.globalSelectionService.routeSegmentsLayers])" [ngClass]="this.globalSelectionService.proceduresLayers.layersSelector.circle  ? 'active' : ''"></div>
            <div class="clear_select" (click)="this.globalSelectionService.clearAllSelected()" [ngClass]="pointsService.getSelectedFeaturesOfType(2).length>0 ? 'active' : ''"></div>
          </div>
          <div>
            <div class="field" *ngFor="let layer of this.globalSelectionService.proceduresLayersMenu" >
              <input type="checkbox" (click)="selectLayer('Procedures', layer)" [checked]="layer.visible" />
              <span> <img src="/assets/img/{{layer.image}}" alt=""/></span>
              <span>{{layer.name}}</span>
              <div class="dots" (mouseover)="utilsService.showHiddenMenu($event)" >...</div>
              <div class="hiddenMenu hiddenMenu__mr&#45;&#45;2" (mouseleave)="utilsService.closeHiddenMenu($event)">
                <ul>
                  <li (click)="mapService.moveLayersToFront([layer])">Move To Front</li>
                  <li (click)="mapService.moveLayersToBack([layer])">Move To Back</li>
                  <li (click)="mapService.zoomToLayers([layer])">Zoom To Layer</li>
                  <li (click)="exportDataService.exportDataToKML([layer])">Export Data to KML</li>
                  <li (click)="exportDataService.exportDataToShapeFile([layer])">Export Data To ShapeFile</li>
                </ul>
              </div>
            </div>
          </div>
      </div>
      <div class="layers__tab" [ngClass]="this.globalSelectionService.proceduresLayers.active ? 'active' : ''">
        <div class="title" >
            <input type="checkbox" (click)="selectAll(this.globalSelectionService.proceduresLayers,$event)"
            [checked]="this.globalSelectionService.proceduresLayers.childLayers[0].allVisible() && checkAllRouteSegmentsVisible()"/>
            <p>{{this.globalSelectionService.proceduresLayers.name}}</p>
            <div title="Procedures Filter" class="filter" (click)="this.showProcedureFilter()"></div>
            <div class="dots" (mouseover)="utilsService.showHiddenMenu($event)">...</div>
            <div class="hiddenMenu hiddenMenu__mr--12" (mouseleave)="utilsService.closeHiddenMenu($event)">
              <ul>
                <li (click)="mapService.moveLayersToFront(this.globalSelectionService.proceduresLayers.childLayers[0].layers)">Move To Front</li>
                <li (click)="mapService.moveLayersToBack(this.globalSelectionService.proceduresLayers.childLayers[0].layers)">Move To Back</li>
                <li (click)="exportDataService.exportDataToKML(this.globalSelectionService.proceduresLayers.childLayers[0].layers)">Export Data to KML</li>
                <li (click)="exportDataService.exportDataToShapeFile(this.globalSelectionService.proceduresLayers.childLayers[0].layers)">Export Data To ShapeFile</li>
              </ul>
            </div>
            <div class="field" *ngFor="let child of this.globalSelectionService.routeSegmentsLayers.childLayers">
              <div class="layers__tab__sec active">
                <div class="options" style="justify-content: space-between;width: 100%;">
                  <div style="display:flex; align-items: center;">

                    <span class="enter"></span>
                    <input type="checkbox" (click)="selectLayer('Route Segments',child)" [checked]="child.allVisible()" />
                    <span class="remove" style="width: 15px;height: 15px;margin-left: 5px;" (click)="this.deleteRouteSegment(child)"></span>
                    <span>{{child.name}}</span>
                    <div class="dots" (mouseover)="utilsService.showHiddenMenu($event)" >...</div>
                    <div class="hiddenMenu hiddenMenu__mr&#45;&#45;2" (mouseleave)="utilsService.closeHiddenMenu($event)">
                      <ul>
                        <li (click)="mapService.moveLayersToFront([child])">Move To Front</li>
                        <li (click)="mapService.moveLayersToBack([child])">Move To Back</li>
                        <li (click)="mapService.zoomToLayers([child])">Zoom To Layer</li>
                        <li (click)="exportDataService.exportDataToKML([layer])">Export Data to KML</li>
                        <li (click)="exportDataService.exportDataToShapeFile([layer])">Export Data To ShapeFile</li>
                      </ul>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>-->

    <!-- RMV KMZ -->
    <!--  <div class="layers__tab" [ngClass]="this.globalSelectionService.trajectoriesLayers.active ? 'active' : ''">

        <div class="title"  >
          <input type="checkbox" (click)="this.selectAll(this.globalSelectionService.trajectoriesLayers, $event)"
          [checked]="this.globalSelectionService.trajectoriesLayers.childLayers[0].allVisible()"/>
          <p>{{this.globalSelectionService.trajectoriesLayers.name}}</p>
            <div title="Manage Trajectories On Map" class="filter" (click)="this.openTrajectoryFilter()"></div>
            <div class="dots" (mouseover)="utilsService.showHiddenMenu($event)">...</div>
            <div class="hiddenMenu hiddenMenu__mr&#45;&#45;12" (mouseleave)="utilsService.closeHiddenMenu($event)">
              <ul>
                <li (click)="mapService.moveLayersToFront(this.globalSelectionService.trajectoriesLayers.childLayers[0].layers)">Move To Front</li>
                <li (click)="mapService.moveLayersToBack(this.globalSelectionService.trajectoriesLayers.childLayers[0].layers)">Move To Back</li>
                <li (click)="exportDataService.exportDataToKML(this.globalSelectionService.trajectoriesLayers.childLayers[0].layers)">Export Data to KML</li>
                <li (click)="exportDataService.exportDataToShapeFile(this.globalSelectionService.trajectoriesLayers.childLayers[0].layers)">Export Data To ShapeFile</li>
              </ul>
            </div>
            <span class="titleTrigger" (click)="this.globalSelectionService.trajectoriesLayers.layersTabTrigger()"></span>
        </div>

        <div class="btn">
          <div class="select_feature" (click)="this.globalSelectionService.setPointer([this.globalSelectionService.trajectoriesLayers])" [ngClass]="this.globalSelectionService.trajectoriesLayers.layersSelector.pointer ? 'active' : ''"></div>
          <div class="polygon_select" (click)="this.globalSelectionService.setBoxSelection([this.globalSelectionService.trajectoriesLayers])" [ngClass]="this.globalSelectionService.trajectoriesLayers.layersSelector.polygon ? 'active' : ''"></div>
          <div class="circle_select" (click)="this.globalSelectionService.setCircleSelection([this.globalSelectionService.trajectoriesLayers])" [ngClass]="this.globalSelectionService.trajectoriesLayers.layersSelector.circle ? 'active' : ''"></div>
          <div class="clear_select" (click)="this.globalSelectionService.clearAllSelected()" [ngClass]="pointsService.getSelectedFeaturesOfType(9).length>0 ? 'active' : ''"></div>
        </div>

        <div>
          <div class="field" *ngFor="let layer of this.globalSelectionService.trajectoriesLayers.childLayers[0].layers" >
            <input type="checkbox" (click)="selectLayer('Trajectories',layer)" [checked]="layer.visible" />
            <span> <img src="/assets/img/{{layer.image}}" alt=""/></span>
            <span>{{layer.name}}</span>
            <div class="dots" (mouseover)="utilsService.showHiddenMenu($event)" >...</div>
            <div class="hiddenMenu hiddenMenu__mr&#45;&#45;2" (mouseleave)="utilsService.closeHiddenMenu($event)">
              <ul>
                <li (click)="mapService.moveLayersToFront([layer])">Move To Front</li>
                <li (click)="mapService.moveLayersToBack([layer])">Move To Back</li>
                <li (click)="mapService.zoomToLayers([layer])">Zoom To Layer</li>
                <li (click)="exportDataService.exportDataToKML([layer])">Export Data to KML</li>
                <li (click)="exportDataService.exportDataToShapeFile([layer])">Export Data To ShapeFile</li>
              </ul>
            </div>
          </div>
        </div>
      </div>-->
    <!-- END RMV KMZ -->

    <!--- Air Space Boundary -->
    <!--    <div class="layers__tab" [ngClass]="this.globalSelectionService.airspaceboundaryLayers.active ? 'active' : ''">
          <div class="title" >
              <input type="checkbox" (click)="this.selectAll(this.globalSelectionService.airspaceboundaryLayers,$event)"
              [checked]="this.globalSelectionService.airspaceboundaryLayers.childLayers[0].allVisible()"/>
              <p>{{this.globalSelectionService.airspaceboundaryLayers.name}}</p>
              <div title="Manage Air Space Boundaries On Map" class="filter" (click)="this.openAirSpaceBoundaryFilter()"></div>
              <div class="dots" (mouseover)="utilsService.showHiddenMenu($event)">...</div>
              <div class="hiddenMenu hiddenMenu__mr&#45;&#45;12" (mouseleave)="utilsService.closeHiddenMenu($event)">
                <ul>
                  <li (click)="mapService.moveLayersToFront(this.globalSelectionService.airspaceboundaryLayers.childLayers[0].layers)">Move To Front</li>
                  <li (click)="mapService.moveLayersToBack(this.globalSelectionService.airspaceboundaryLayers.childLayers[0].layers)">Move To Back</li>
                  <li (click)="exportDataService.exportDataToKML(this.globalSelectionService.airspaceboundaryLayers.childLayers[0].layers)">Export Data to KML</li>
                  <li (click)="exportDataService.exportDataToShapeFile(this.globalSelectionService.airspaceboundaryLayers.childLayers[0].layers)">Export Data To ShapeFile</li>

              </ul>
            </div>
            <span class="titleTrigger" (click)="this.globalSelectionService.airspaceboundaryLayers.layersTabTrigger()"></span>
        </div>
        <div class="btn">
          <div class="select_feature" (click)="this.globalSelectionService.setPointer([this.globalSelectionService.airspaceboundaryLayers])" [ngClass]="this.globalSelectionService.airspaceboundaryLayers.layersSelector.pointer ? 'active' : ''"></div>
          <div class="polygon_select" (click)="this.globalSelectionService.setBoxSelection([this.globalSelectionService.airspaceboundaryLayers])" [ngClass]="this.globalSelectionService.airspaceboundaryLayers.layersSelector.polygon ? 'active' : ''"></div>
          <div class="circle_select" (click)="this.globalSelectionService.setCircleSelection([this.globalSelectionService.airspaceboundaryLayers])" [ngClass]="this.globalSelectionService.airspaceboundaryLayers.layersSelector.circle ? 'active' : ''"></div>
          <div class="clear_select" (click)="this.globalSelectionService.clearAllSelected()" [ngClass]="pointsService.getSelectedFeaturesOfType(5).length>0 ? 'active' : ''"></div>
        </div>
        <div>
          <div class="field" *ngFor="let layer of this.globalSelectionService.airspaceboundaryLayers.childLayers[0].layers" >
            <input type="checkbox" (click)="selectLayer('Air Space Boundaries', layer)" [checked]="layer.visible" />
            <span> <img src="/assets/img/{{layer.image}}" alt=""/></span>
            <span>{{layer.name}}</span>
            <div class="dots" (mouseover)="utilsService.showHiddenMenu($event)" >...</div>
            <div class="hiddenMenu hiddenMenu__mr--2" (mouseleave)="utilsService.closeHiddenMenu($event)">
              <ul>
                <li (click)="mapService.moveLayersToFront([layer])">Move To Front</li>
                <li (click)="mapService.moveLayersToBack([layer])">Move To Back</li>
                <li (click)="mapService.zoomToLayers([layer])">Zoom To Layer</li>
                <li (click)="exportDataService.exportDataToKML([layer])">Export Data to KML</li>
                <li (click)="exportDataService.exportDataToShapeFile([layer])">Export Data To ShapeFile</li>
              </ul>
            </div>
          </div>
        </div>
      </div>
      <div class="layers__tab" [ngClass]="this.globalSelectionService.saamTrafficDensityLayer.active ? 'active' : ''">
        <div class="title">
            <input type="checkbox" (click)="this.selectLayer('SAAM Traffic Densities',this.globalSelectionService.saamTrafficDensityLayer)" [checked]="this.globalSelectionService.saamTrafficDensityLayer.childLayers[0].layers[0].visible"/>
            <p>{{this.globalSelectionService.saamTrafficDensityLayer.name}}</p>
            <div title="Manage SAAM Traffic Layers On Map" class="filter" (click)="openSAAMFilter()" ></div>
            <div  class="dots" (mouseover)="utilsService.showHiddenMenu($event)">...</div>
            <div class="hiddenMenu hiddenMenu__mr--12" (mouseleave)="utilsService.closeHiddenMenu($event)">
              <ul>
                <li (click)="mapService.moveLayersToFront(this.globalSelectionService.saamTrafficDensityLayer.childLayers)">Move To Front</li>
                <li (click)="mapService.moveLayersToBack(this.globalSelectionService.saamTrafficDensityLayer.childLayers)">Move To Back</li>
                <li (click)="exportDataService.exportDataToKML(this.globalSelectionService.saamTrafficDensityLayer.childLayers[0].layers)">Export Data to KML</li>
                <li (click)="exportDataService.exportDataToShapeFile(this.globalSelectionService.saamTrafficDensityLayer.childLayers[0].layers)">Export Data To ShapeFile</li>
              </ul>
            </div>

            <span class="titleTrigger" (click)="this.globalSelectionService.saamTrafficDensityLayer.layersTabTrigger()"></span>
        </div>
        <div class="btn">
          <div class="select_feature" (click)="this.globalSelectionService.setPointer([this.globalSelectionService.saamTrafficDensityLayer])" [ngClass]="this.globalSelectionService.saamTrafficDensityLayer.layersSelector.pointer ? 'active' : ''"></div>
          <div class="polygon_select" (click)="this.globalSelectionService.setBoxSelection([this.globalSelectionService.saamTrafficDensityLayer])" [ngClass]="this.globalSelectionService.saamTrafficDensityLayer.layersSelector.polygon ? 'active' : ''"></div>
          <div class="circle_select" (click)="this.globalSelectionService.setCircleSelection([this.globalSelectionService.saamTrafficDensityLayer])" [ngClass]="this.globalSelectionService.saamTrafficDensityLayer.layersSelector.circle ? 'active' : ''"></div>
          <div class="clear_select" (click)="this.globalSelectionService.clearAllSelected()" [ngClass]="pointsService.getSelectedFeaturesOfType(12).length>0 ? 'active' : ''"></div>
        </div>
        <div>
          <div class="field" *ngFor="let topLevelLayer of this.globalSelectionService.saamTrafficDensityLayer.childLayers"  >
            <div class="layers__tab__sec"  style="padding: 0; margin: 0;width: 99% !important;" [ngClass]="topLevelLayer.status ? 'active' : ''">
              <div class="title">
                <input type="checkbox" (click)="selectLayer('SAAM Traffic Densities', topLevelLayer.layers[0])" [checked]="topLevelLayer.layers[0].visible" />
                <span> <img src="/assets/img/{{topLevelLayer.layers[0].image}}" alt=""/></span>
                <span style="padding-left: 5px;padding-right: 58px;" class="trigger" (click)="this.globalSelectionService.saamTrafficDensityLayer.clickEvent(topLevelLayer)">{{topLevelLayer.name}}</span>
                <div class="hiddenMenu hiddenMenu__mr--2" (mouseleave)="utilsService.closeHiddenMenu($event)">
                  <ul>
                    <li (click)="mapService.moveLayersToFront([topLevelLayer])">Move To Front</li>
                    <li (click)="mapService.moveLayersToBack([topLevelLayer])">Move To Back</li>
                    <li (click)="mapService.zoomToLayers([topLevelLayer])">Zoom To Layer</li>
                  </ul>
                </div>
              </div>
              <div class="layers__tab__third active" >
                <div>
                  <div class="field" style="padding-left: 20px;">
                    <span>
                      <svg class="test" viewBox="0 0 23.52 21.14"><defs><style>.cls-1,.cls-2{stroke:#000;stroke-miterlimit:10;}</style></defs><g id="Layer_2" data-name="Layer 2"><g id="Layer_1-2" data-name="Layer 1"><rect class="cls-1" x="0.5" y="0.5" width="1.11" height="20.14"/><polygon class="cls-2" [ngStyle]="{ fill : 'black'}" points="11.81 18.57 1.89 18.57 12.38 0.5 22.64 0.5 11.81 18.57"/></g></g></svg>
                      <span>0 - 4 No cell</span>
                    </span>
                  </div>
                </div>
                <div>
                  <div class="field" style="padding-left: 20px;">
                    <span>
                      <svg class="test" viewBox="0 0 23.52 21.14"><defs><style>.cls-1,.cls-2{stroke:#000;stroke-miterlimit:10;}</style></defs><g id="Layer_2" data-name="Layer 2"><g id="Layer_1-2" data-name="Layer 1"><rect class="cls-1" x="0.5" y="0.5" width="1.11" height="20.14"/><polygon class="cls-2" [ngStyle]="{ fill : 'green'}" points="11.81 18.57 1.89 18.57 12.38 0.5 22.64 0.5 11.81 18.57"/></g></g></svg>
                      <span> 5 - 9 </span>
                    </span>
                  </div>
                </div>
                <div>
                  <div class="field" style="padding-left: 20px;">
                    <span>
                      <svg class="test" viewBox="0 0 23.52 21.14"><defs><style>.cls-1,.cls-2{stroke:#000;stroke-miterlimit:10;}</style></defs><g id="Layer_2" data-name="Layer 2"><g id="Layer_1-2" data-name="Layer 1"><rect class="cls-1" x="0.5" y="0.5" width="1.11" height="20.14"/><polygon class="cls-2" [ngStyle]="{ fill : 'rgb(0,150,0)'}" points="11.81 18.57 1.89 18.57 12.38 0.5 22.64 0.5 11.81 18.57"/></g></g></svg>
                      <span>10- 19</span>
                    </span>
                  </div>
                </div>
                <div>
                  <div class="field" style="padding-left: 20px;">
                    <span>
                      <svg class="test" viewBox="0 0 23.52 21.14"><defs><style>.cls-1,.cls-2{stroke:#000;stroke-miterlimit:10;}</style></defs><g id="Layer_2" data-name="Layer 2"><g id="Layer_1-2" data-name="Layer 1"><rect class="cls-1" x="0.5" y="0.5" width="1.11" height="20.14"/><polygon class="cls-2" [ngStyle]="{ fill : 'yellow'}" points="11.81 18.57 1.89 18.57 12.38 0.5 22.64 0.5 11.81 18.57"/></g></g></svg>
                      <span>20 - 49</span>
                    </span>
                  </div>
                </div>
                <div>
                  <div class="field" style="padding-left: 20px;">
                    <span>
                      <svg class="test" viewBox="0 0 23.52 21.14"><defs><style>.cls-1,.cls-2{stroke:#000;stroke-miterlimit:10;}</style></defs><g id="Layer_2" data-name="Layer 2"><g id="Layer_1-2" data-name="Layer 1"><rect class="cls-1" x="0.5" y="0.5" width="1.11" height="20.14"/><polygon class="cls-2" [ngStyle]="{ fill : 'orange'}" points="11.81 18.57 1.89 18.57 12.38 0.5 22.64 0.5 11.81 18.57"/></g></g></svg>
                      <span>50 - 99</span>
                    </span>
                  </div>
                </div>
                <div>
                  <div class="field" style="padding-left: 20px;">
                    <span>
                      <svg class="test" viewBox="0 0 23.52 21.14"><defs><style>.cls-1,.cls-2{stroke:#000;stroke-miterlimit:10;}</style></defs><g id="Layer_2" data-name="Layer 2"><g id="Layer_1-2" data-name="Layer 1"><rect class="cls-1" x="0.5" y="0.5" width="1.11" height="20.14"/><polygon class="cls-2" [ngStyle]="{ fill : 'rgb(200,50,0)'}" points="11.81 18.57 1.89 18.57 12.38 0.5 22.64 0.5 11.81 18.57"/></g></g></svg>
                      <span>100 - 199</span>
                    </span>
                  </div>
                </div>
                <div>
                  <div class="field" style="padding-left: 20px;">
                    <span>
                      <svg class="test" viewBox="0 0 23.52 21.14"><defs><style>.cls-1,.cls-2{stroke:#000;stroke-miterlimit:10;}</style></defs><g id="Layer_2" data-name="Layer 2"><g id="Layer_1-2" data-name="Layer 1"><rect class="cls-1" x="0.5" y="0.5" width="1.11" height="20.14"/><polygon class="cls-2" [ngStyle]="{ fill : 'red'}" points="11.81 18.57 1.89 18.57 12.38 0.5 22.64 0.5 11.81 18.57"/></g></g></svg>
                      <span>>200</span>
                    </span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

      </div>
      <div *ngIf="this.globalSelectionService.flightInspectionLayer.childLayers.length != 0" class="layers__tab" [ngClass]="this.globalSelectionService.flightInspectionLayer.active ? 'active' : ''">
        <div class="title">
          <input type="checkbox" (click)="this.selectLayer('Flight Inspections',this.globalSelectionService.flightInspectionLayer,$event)" [checked]="this.globalSelectionService.flightInspectionLayer.allLayersVisible()"/>
          <p>{{this.globalSelectionService.flightInspectionLayer.name}}</p>
          <div class="dots" style="right: -27px" (mouseover)="utilsService.showHiddenMenu($event)">...</div>
          <div class="hiddenMenu hiddenMenu__mr--12" (mouseleave)="utilsService.closeHiddenMenu($event)">
            <ul>
              <li (click)="mapService.moveLayersToFront(this.globalSelectionService.flightInspectionLayer.childLayers)">Move To Front</li>
              <li (click)="mapService.moveLayersToBack(this.globalSelectionService.flightInspectionLayer.childLayers)">Move To Back</li>
              <li (click)="exportDataService.exportDataToKML(getFlightInspectionLayers())">Export Data to KML</li>
              <li (click)="exportDataService.exportDataToShapeFile(getFlightInspectionLayers())">Export Data To ShapeFile</li>

              </ul>
            </div>
            <span class="titleTrigger" (click)="this.globalSelectionService.flightInspectionLayer.layersTabTrigger()"></span>
          </div>
          <div class="btn">
            <div class="select_feature" (click)="this.globalSelectionService.setPointer([this.globalSelectionService.flightInspectionLayer])" [ngClass]="this.globalSelectionService.flightInspectionLayer.layersSelector.pointer ? 'active' : ''"></div>
            <div class="polygon_select" (click)="this.globalSelectionService.setBoxSelection([this.globalSelectionService.flightInspectionLayer])" [ngClass]="this.globalSelectionService.flightInspectionLayer.layersSelector.polygon ? 'active' : ''"></div>
            <div class="circle_select" (click)="this.globalSelectionService.setCircleSelection([this.globalSelectionService.flightInspectionLayer])" [ngClass]="this.globalSelectionService.flightInspectionLayer.layersSelector.circle ? 'active' : ''"></div>
            <div class="clear_select" (click)="this.globalSelectionService.clearAllSelected()" [ngClass]="pointsService.getSelectedFeaturesOfType(14).length>0 ? 'active' : ''"></div>
          </div>
          <div class="field" *ngFor="let topLevelLayer of this.globalSelectionService.flightInspectionLayer.childLayers">
            <div class="layers__tab__sec"  style="padding: 0; margin: 0;width: 99% !important;" [ngClass]="topLevelLayer.status ? 'active' : ''">
              <div class="title">
                <input type="checkbox" (click)="selectLayer('Flight Inspections',topLevelLayer.layers[0])" [checked]="topLevelLayer.layers[0].visible">
                <span> <img src="/assets/img/{{topLevelLayer.layers[0].image}}" alt=""/></span>
                <span class="trigger" (click)="this.globalSelectionService.flightInspectionLayer.clickEvent(topLevelLayer)">
                  {{topLevelLayer.index_selected != null? topLevelLayer.name + ' - ' + topLevelLayer.flightInspection_attributes[topLevelLayer.index_selected].name  :  topLevelLayer.name }}</span>
                <div class="dots" style="right: 17px"(mouseover)="utilsService.showHiddenMenu($event)">...</div>
                <div class="hiddenMenu hiddenMenu__mr&#45;&#45;12" (mouseleave)="utilsService.closeHiddenMenu($event)">
                  <ul>
                    <li *ngFor="let attribute of topLevelLayer.flightInspection_attributes;let i = index" (click)="pointsService.changeFlightInspectionAttribute(topLevelLayer,i)">{{attribute.navaidID == null? attribute.name + ' - '+attribute.units :attribute.navaidID + ' - '+  attribute.name + ' - '+attribute.units }}</li>
                    <div class="separator"></div>
                    <li (click)="mapService.moveLayersToFront([topLevelLayer])">Move To Front</li>
                    <li (click)="mapService.moveLayersToBack([topLevelLayer])">Move To Back</li>
                    <li (click)="mapService.zoomToLayers([topLevelLayer])">Zoom To Layer</li>
                    <li (click)="exportDataService.exportDataToKML([topLevelLayer.layers[0]])">Export Data to KML</li>
                    <li (click)="exportDataService.exportDataToShapeFile([topLevelLayer.layers[0]])">Export Data To ShapeFile</li>
                  </ul>
                </div>
              </div>
              <div *ngIf="topLevelLayer.index_selected != null" class="layers__tab__third active" >
                <div  *ngFor="let colorInterval of topLevelLayer.flightInspection_attributes[topLevelLayer.index_selected].style">
                  <div class="field" style="padding-left: 20px;">
                    <span>
                      <svg class="test" viewBox="0 0 23.52 21.14"><defs><style>.cls-1,.cls-2{stroke:#000;stroke-miterlimit:10;}</style></defs><g id="Layer_2" data-name="Layer 2"><g id="Layer_1-2" data-name="Layer 1"><rect class="cls-1" x="0.5" y="0.5" width="1.11" height="20.14"/><polygon class="cls-2" [ngStyle]="{ fill : colorInterval.color}" points="11.81 18.57 1.89 18.57 12.38 0.5 22.64 0.5 11.81 18.57"/></g></g></svg>
                      <span>{{getFlightInspectionLegend(colorInterval)}}</span>
                    </span>
                  </div>
                </div>
              </div>
            </div>

          </div>
        </div>-->

    <!--  <div *ngIf="this.globalSelectionService.processingToolLayer.childLayers.length != 0" class="layers__tab" [ngClass]="this.globalSelectionService.processingToolLayer.active ? 'active' : ''">
        <div class="title">
          <input type="checkbox" (click)="this.selectLayer('Processing Tool',this.globalSelectionService.processingToolLayer,$event)" [checked]="this.globalSelectionService.processingToolLayer.allLayersVisible()"/>
          <p>{{this.globalSelectionService.processingToolLayer.name}}</p>
          <div class="dots" style="right: -27px" (mouseover)="utilsService.showHiddenMenu($event)">...</div>
          <div class="hiddenMenu" (mouseleave)="utilsService.closeHiddenMenu($event)">
            <ul>
              <li (click)="mapService.moveLayersToFront(this.globalSelectionService.processingToolLayer.childLayers)">Move To Front</li>
              <li (click)="mapService.moveLayersToBack(this.globalSelectionService.processingToolLayer.childLayers)">Move To Back</li>
            </ul>
          </div>
          <span class="titleTrigger" (click)="this.globalSelectionService.processingToolLayer.layersTabTrigger()"></span>
        </div>
        <div class="btn">
          <div class="select_feature" (click)="this.globalSelectionService.setPointer([this.globalSelectionService.processingToolLayer])" [ngClass]="this.globalSelectionService.processingToolLayer.layersSelector.pointer ? 'active' : ''"></div>
          <div class="polygon_select" (click)="this.globalSelectionService.setBoxSelection([this.globalSelectionService.processingToolLayer])" [ngClass]="this.globalSelectionService.processingToolLayer.layersSelector.polygon ? 'active' : ''"></div>
          <div class="circle_select" (click)="this.globalSelectionService.setCircleSelection([this.globalSelectionService.processingToolLayer])" [ngClass]="this.globalSelectionService.processingToolLayer.layersSelector.circle ? 'active' : ''"></div>
          <div class="clear_select" (click)="this.globalSelectionService.clearAllSelected()" [ngClass]="pointsService.getSelectedFeaturesOfType(15).length>0 ? 'active' : ''"></div>
        </div>
        <div class="field" *ngFor="let topLevelLayer of this.globalSelectionService.processingToolLayer.childLayers">
          <div class="layers__tab__sec"  style="padding: 0; margin: 0;width: 99% !important;" [ngClass]="topLevelLayer.status ? 'active' : ''">
            <div class="title">
              <input type="checkbox" (click)="selectLayer('Processing Tool',topLevelLayer.layers[0])" [checked]="topLevelLayer.layers[0].visible">
              <span> <img src="/assets/img/{{topLevelLayer.layers[0].image}}" alt=""/></span>
              <span class="trigger" style="-webkit-box-orient: vertical;" title="{{topLevelLayer.layers[0].name}}" (click)="this.globalSelectionService.processingToolLayer.clickEvent(topLevelLayer)">{{topLevelLayer.layers[0].name}}</span>
              <div class="dots" style="right: 17px"(mouseover)="utilsService.showHiddenMenu($event)">...</div>
              <div class="hiddenMenu" (mouseleave)="utilsService.closeHiddenMenu($event)">
                <ul>
                  <li *ngFor="let attribute of topLevelLayer.processingTool_attributes;let i = index" (click)="pointsService.changeProcessingToolAttribute(topLevelLayer,i)">{{attribute.name + ' - '+attribute.units}}</li>
                  <div class="separator"></div>
                  <li (click)="exportService.showExportProcessingToolModal(topLevelLayer)">Export Processing Tool Values</li>
                  <li (click)="mapService.moveLayersToFront([topLevelLayer])">Move To Front</li>
                  <li (click)="mapService.moveLayersToBack([topLevelLayer])">Move To Back</li>
                  <li (click)="mapService.zoomToLayers([topLevelLayer])">Zoom To Layer</li>
                </ul>
              </div>
            </div>
            <div *ngIf="topLevelLayer.index_selected != null" class="layers__tab__third active" >
              <div  *ngFor="let colorInterval of topLevelLayer.processingTool_attributes[topLevelLayer.index_selected].style">
                <div class="field" style="padding-left: 20px;">
                  <span>
                    <svg class="test" viewBox="0 0 23.52 21.14"><defs><style>.cls-1,.cls-2{stroke:#000;stroke-miterlimit:10;}</style></defs><g id="Layer_2" data-name="Layer 2"><g id="Layer_1-2" data-name="Layer 1"><rect class="cls-1" x="0.5" y="0.5" width="1.11" height="20.14"/><polygon class="cls-2" [ngStyle]="{ fill : colorInterval.color}" points="11.81 18.57 1.89 18.57 12.38 0.5 22.64 0.5 11.81 18.57"/></g></g></svg>
                    <span>{{getFlightInspectionLegend(colorInterval)}}</span>
                  </span>
                </div>
              </div>
            </div>
          </div>

        </div>
      </div>-->


    <!-- END ROUTE SEGMENTS-->
  </div>
</div>
